import { ColumnType } from 'antd/es/table'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from 'UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'

export const offshoreColumns: ColumnType<any>[] = [
  columns[COLUMNS_IDS.profileNames],
  columns[COLUMNS_IDS.verifiedName],
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.reportStatus],
  columns[COLUMNS_IDS.offshoreLinkedEntities],
  columns[COLUMNS_IDS.offshoreOfficerRole],
  columns[COLUMNS_IDS.firstActivityOverview],
  columns[COLUMNS_IDS.lastActivity],
  columns[COLUMNS_IDS.addresses],
  columns[COLUMNS_IDS.zone],
  columns[COLUMNS_IDS.activityType],
  columns[COLUMNS_IDS.caseId],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  offshoreColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
